import { PaymentProperty } from "@circle-react-shared/Paywalls/Modals/ChargeDetailsModal/Properties/PaymentMethodProperty/PaymentProperty";

export const PaymentMethodColumn = ({ charge }: any) => (
  <PaymentProperty charge={charge} />
);
